import { type HttpPostFormData, mapServerError } from '@/shared/infra/http'
import type {
  UploadFeedbackAttachment,
  UploadFeedbackAttachmentResult,
} from '@/modules/feedback/use-cases'

export class SupabaseUploadFeedbackAttachmentRepository {
  constructor(private readonly http: HttpPostFormData) {}

  execute: UploadFeedbackAttachment = async ({ file }) => {
    const form = new FormData()
    form.append('file', file, file.name)

    try {
      return await this.http.postFormData<UploadFeedbackAttachmentResult>({
        url: '/feedback/attachment',
        body: form,
      })
    } catch (err) {
      mapServerError(err, {})
    }
  }
}
